import React, { FC } from 'react';

import { getClassNames } from './HighContrastBorder.styles';
import { HighContrastBorderProps } from './HighContrastBorder.types';

const HighContrastBorder: FC<HighContrastBorderProps> = ({
  top = false,
  right = false,
  bottom = false,
  left = false,
  full = false,
  className,
  children,
}) => <div className={getClassNames(top, right, bottom, left, full, className).highContrastBorder}>{children}</div>;

export default HighContrastBorder;
